import script from "./AnyDocCard20321.vue?vue&type=script&setup=true&lang=ts"
export * from "./AnyDocCard20321.vue?vue&type=script&setup=true&lang=ts"

import "./AnyDocCard20321.vue?vue&type=style&index=0&id=3c045a5f&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3c045a5f"]])

export default __exports__